import React from 'react';

import Link from 'components/atoms/Link';

export interface BreadcrumbType {
  text?: string,
  slug?: string
}
export interface BreadcrumbProps {
  items?: BreadcrumbType[]
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => (
  <div className="m-breadcrumb a-paragraph-text a-paragraph-text-raisinBlack07">
    <ol itemScope itemType="https://schema.org/BreadcrumbList">
      {
        items
        && items.map(
          (item, index) => (
            <li key={`li-bread-crumb-item${index + 1}`} className={`${index === 0 ? 'm-breadcrumb_li_first' : 'm-breadcrumb_li'}`} itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
              <Link itemProp="item" key={`bread-crumb-item${index + 1}`} href={`${item.slug === '/' ? '' : '/'}${item.slug}`}>
                <span itemProp="name">
                  {item.text}
                </span>
              </Link>
              <meta itemProp="position" content={`${index + 1}`} />
            </li>
          )
        )
      }
    </ol>
  </div>

);

Breadcrumb.defaultProps = {
};

export default Breadcrumb;
